import { AtlasCore } from "@/app/core/atlas-core";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

export const mountAtlas = () => {
  const documentRoot = document.getElementById("root")!;

  createRoot(documentRoot).render(
    <StrictMode>
      <AtlasCore />
    </StrictMode>
  );
};
